import * as React from "react";
import type { SVGProps } from "react";
const SvgSystemExchangeWebIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="system_exchange_web_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M147.2 149.333c-22.4 0-40.533 19.115-40.533 42.667s18.133 42.667 40.533 42.667h729.6c22.4 0 40.533-19.115 40.533-42.667S899.2 149.333 876.8 149.333H147.2zm0 640c-22.4 0-40.533 19.115-40.533 42.667s18.133 42.667 40.533 42.667h729.6c22.4 0 40.533-19.115 40.533-42.667S899.2 789.333 876.8 789.333H147.2zm764.16-319.616L814.208 586.24a29.397 29.397 0 0 1-6.656 5.845c-13.739 8.832-33.024 6.23-43.093-5.845l-97.152-116.48a24.917 24.917 0 0 1-5.931-16c0-14.933 13.781-27.05 30.805-27.05h194.39c6.528 0 12.928 1.834 18.176 5.247 13.738 8.79 16.725 25.728 6.656 37.803zm-762.027-.384a42.667 42.667 0 1 0 0 85.334h384a42.667 42.667 0 1 0 0-85.334h-384z"
    />
  </svg>
);
export default SvgSystemExchangeWebIcon;
